import React from 'react'
import ContentLoader from 'react-content-loader'

import styles from './index.module.scss'

export default function LoadingHomepage() {
  return (
    <div className={styles.container}>
      <ContentLoader
        viewBox="0 0 400 880"
        backgroundOpacity={0.1}
        foregroundColor="#333"
        foregroundOpacity={0.05}
      >
        <rect x="0" y="0" width="400" height="200" />
        <rect x="0" y="220" width="400" height="30" />
        <rect x="0" y="270" width="100" height="40" rx="16" ry="16" />
        <rect x="150" y="270" width="100" height="40" rx="16" ry="16" />
        <rect x="300" y="270" width="100" height="40" rx="16" ry="16" />
        <rect x="0" y="330" width="100" height="40" rx="16" ry="16" />
        <rect x="150" y="330" width="100" height="40" rx="16" ry="16" />
        <rect x="300" y="330" width="100" height="40" rx="16" ry="16" />
        <rect x="0" y="400" width="400" height="40" />
        <rect x="0" y="470" width="400" height="30" />
        <rect x="0" y="520" width="400" height="30" />
        <rect x="0" y="570" width="400" height="30" />
        <rect x="0" y="620" width="400" height="30" />
        <rect x="0" y="670" width="400" height="30" />
        <rect x="0" y="720" width="400" height="30" />
        <rect x="0" y="770" width="400" height="30" />
        <rect x="0" y="820" width="400" height="30" />
        <rect x="0" y="880" width="400" height="40" />
      </ContentLoader>
    </div>
  )
}
